export default __webpack_public_path__ + "static/media/image@3x.4570c80f.png";